module.exports = __webpack_public_path__ + "5d63b5cf3e32637b3d6cb26153a36d83.png";